import "./chests.css"
import {usePumpStore} from "../../../store/pumpStore";
import closed from "./assets/closed.png"
import openChest from "./assets/open.png"
import blockTitle from "./assets/title.png"
import {useState} from "react";
import axios from "axios";
import React from "react";
import {levels} from "../../../helpers/levelHelpers";
import {initHapticFeedback} from "@telegram-apps/sdk-react";
import parse from "html-react-parser";
import {Locales} from "../../../helpers/localeHelpers";
import SlotCounter from "react-slot-counter";
import coin from "../../../assets/coin.svg";


export const Chests = () => {
    const {level, appInitData, selectedAnswer, setIsExploding, setWinAmountClass, setEquity,  setCorrectAnswer, setSelectedAnswer, setAnswerChosen, setWinAmount, setStatus,
        chestsType, setShowChests, taskNumber, setShowShield, artifacts, language, basePrice, equity, equityClass, equityTitleClass} = usePumpStore()
    const [chestsList, setChestsList] = useState([
        {status: 'closed', icon: closed},
        {status: 'closed', icon: closed},
        {status: 'closed', icon: closed}
    ])
    const hapticFeedback = initHapticFeedback();

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }


    const checkChest = (index) => {
        let eqi = 0.0
        axios.post('https://pump.stt.market/api/chest', {'chat_id': appInitData.user.id, 'type': chestsType, 'chest': index}).then((res) => {
            const data = res.data
            if (['multiply', 'add'].includes(data.method)) {
                hapticFeedback.notificationOccurred('success');
                window.scrollTo(0, 0)
                if (data.method === 'multiply') {
                    setWinAmount('x2')
                } else {
                    setWinAmount('+ ' + parseFloat(data.bonus).toFixed(2))
                }
                setStatus('success')
                setIsExploding(true)
                setCorrectAnswer(selectedAnswer)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small')
                },1000)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small _eq')
                },1150)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small _eq _fin')
                },1350)
                setTimeout(function () {
                    setEquity(parseFloat(data.amount))
                }, 1350)
                setTimeout(function () {
                    setStatus('idle')
                    setWinAmountClass('win-amount')
                    setSelectedAnswer('')
                    setCorrectAnswer('')
                    setAnswerChosen(false)
                    setShowChests(false)
                }, 2000)
            } else if (['divide', 'remove'].includes(data.method)) {
                hapticFeedback.notificationOccurred('error');
                window.scrollTo(0, 0)
                if (data.method === 'divide') {
                    setWinAmount('/ 2')
                } else {
                    setWinAmount('- ' + parseFloat(data.bonus).toFixed(2))
                }
                setStatus('fail')
                if (artifacts.includes('shield')) {
                    setShowShield(true)
                }
                setTimeout(function (){
                    setWinAmountClass('win-amount _small')
                },1000)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small _eq')
                    setShowShield(false)
                },1150)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small _eq _fin')
                },1350)
                setTimeout(function () {
                    if (!artifacts.includes('shield')) {
                        setEquity(parseFloat(data.amount))
                    }
                }, 1350)
                setTimeout(function () {
                    setStatus('idle')
                    setWinAmountClass('win-amount')
                    setSelectedAnswer('')
                    setAnswerChosen(false)
                    setCorrectAnswer('')
                    setShowChests()
                }, 2000)
            } else {
                window.scrollTo(0, 0)
                setWinAmount(0)
                setStatus('fail')
                setTimeout(function (){
                    setWinAmountClass('win-amount _small')
                },1000)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small _eq')
                },1150)
                setTimeout(function (){
                    setWinAmountClass('win-amount _small _eq _fin')
                },1350)
                setTimeout(function () {

                }, 1350)
                setTimeout(function () {
                    setStatus('idle')
                    setWinAmountClass('win-amount')
                    setSelectedAnswer('')
                    setAnswerChosen(false)
                    setCorrectAnswer('')
                    setShowChests()
                }, 2000)
            }
        })
        chestsList[index].icon = openChest
        setChestsList([...chestsList])
    }

    return (
        <React.Fragment>
            <div className={"task__info"} style={{justifyContent: "center"}}>
                <div>
                    <div className={equityTitleClass}>equity</div>
                    <div className={equityClass} style={{color: equity >= 0 ? '#38e476' : '#EF7B99'}}>{equity >= 0 ? '+' : ''} <SlotCounter value={numberWithCommas(equity)} /></div>
                </div>
            </div>
            <div className={"chests"}>
                <img src={blockTitle} alt={''} className={"chests__title"}/>
                <div className={"chests__item _first"} onClick={() => checkChest(0)}>
                    <img src={chestsList[0].icon} alt={''} key={chestsList[0].icon} />
                </div>
                <div className={"chests__item _second"} onClick={() => checkChest(1)}>
                    <img src={chestsList[1].icon} alt={''} key={chestsList[1].icon} />
                </div>
                <div className={"chests__item _third"} onClick={() => checkChest(2)}>
                    <img src={chestsList[2].icon} alt={''} key={chestsList[2].icon} />
                </div>
                {taskNumber === 5 &&
                    <div className={"chests__help"}>{parse(Locales[language].chestFirst)}</div>
                }
                {taskNumber === 11 &&
                    <div className={"chests__help"}>{parse(Locales[language].chestSecond[0])}{(parseFloat(basePrice) * 10 * levels[level].multiplicator).toFixed(2)}{parse(Locales[language].chestSecond[1])}{(parseFloat(basePrice) * 10 * levels[level].multiplicator).toFixed(2)}{parse(Locales[language].chestSecond[2])}</div>
                }
            </div>

        </React.Fragment>
    )
}